module.exports = __webpack_public_path__ + "static/media/club.2a624111.png";